/**
 * Created by markusr on 2.6.2015.
 */

define('helperLayout-prependContent',['helperLayout-createNode'], function(createNode) {
    'use strict';

    var prependContent = function(options) {
        var node = createNode(options),
            containerID = options.containerID || '',
            container = (containerID) ? document.getElementById(containerID) : document.getElementsByTagName('head')[0];

        container = container || document.documentElement;

        if(node) {
            if(containerID){
                container.insertBefore(node, container.firstChild);
            }else {
                // Add to head as 2nd child because main.css needs to be the 1st
                container.insertBefore(node, container.childNodes[1]);
            }
        }
    };

    return prependContent;

});

